"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
define('app/document/diff/document.diff.view',['require','exports','module','rs/abstract.content.view','rs/form/section.controller','rs/helper','underscore','backbone.radio'],function (require, exports, module) {
  'use strict';

  var AbstractContentView = require('rs/abstract.content.view');
  var FormSectionController = require('rs/form/section.controller');
  var helper = require('rs/helper');
  var _ = require('underscore');
  var Radio = require('backbone.radio');
  var FORM_OBJECT_CHANNEL = Radio.channel('formobject');
  var DocumentDiffView = AbstractContentView.extend({
    templates: {
      'document.diff.init': 'renderInitFragment',
      'form.diff.section.row': 'renderSectionRowFragment'
    },
    events: {
      'click .form-diff-sidebar-closer': 'handleSideBarToggle',
      'keydown .form-diff-sidebar-closer': 'handleSideBarKeydown',
      'click .form-diff-control': 'handleDiffControlClick',
      'keydown .form-diff-control': 'handleDiffControlKeydown',
      'click .form-sidebar-section': 'handleSectionClick',
      'keydown .form-sidebar-section': 'handleSectionKeydown',
      'click [data-section-nav]': 'handleSectionNavClick',
      'change .document-selector': 'handleDocumentSelectorChange',
      'click .compare-button.active': 'handleCompareButtonClick',
      'keydown .compare-button.active': 'handleCompareButtonKeydown',
      'click .attachment-diff-viewer-close': 'hideDocumentDiffViewer',
      'keydown .attachment-diff-viewer-close': 'hideDocumentDiffViewerKeydown'
    },
    initialize: function initialize() {
      AbstractContentView.prototype.initialize.apply(this, arguments);
      this.listenTo(FORM_OBJECT_CHANNEL, 'formobject:render', function (formObjectView) {
        var PREFIX = 'prev-';
        var previousFormObjectContainer = formObjectView.$el.parents('.form-container-left');
        var previousFormObjectIds;
        if (previousFormObjectContainer && previousFormObjectContainer.length > 0) {
          formObjectView.$el.attr({
            id: PREFIX + formObjectView.$el.attr('id')
          });
          previousFormObjectIds = formObjectView.$el.find('[id^="fo-"], [for^="fo-"]');
          previousFormObjectIds.each(function (ind, domItem) {
            var $item = $(domItem);
            if ($item.attr('id')) {
              $item.attr({
                id: PREFIX + $item.attr('id')
              });
            }
            if ($item.attr('for')) {
              $item.attr({
                "for": PREFIX + $item.attr('for')
              });
            }
          });
        }
      });
    },
    hideDocumentDiffViewerKeydown: function hideDocumentDiffViewerKeydown(ev) {
      if (ev.keyCode === 13) {
        this.hideDocumentDiffViewer();
      }
    },
    handleCompareButtonClick: function handleCompareButtonClick(ev) {
      var diffIframeDiv = this.getDiffIframeContainer();
      var formObjectId = ev.target.getAttribute('data-formObjectid');
      diffIframeDiv.css('display', 'block');
      this.setNavigationPreviousText('COMPARE FORMS');
      $('div.form-section-navigation').addClass('disabled');
      this.compareAttachments(formObjectId);
    },
    handleCompareButtonKeydown: function handleCompareButtonKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleCompareButtonClick(ev);
      }
    },
    handleSectionKeydown: function handleSectionKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleSectionClick(ev);
      }
    },
    handleSectionClick: function handleSectionClick(ev) {
      var section = helper.datum(ev.currentTarget);
      if (this.getDelegate().getActiveSection() != section) {
        this.getDelegate().activateSection(section);
      }
    },
    handleSectionNavClick: function handleSectionNavClick(ev) {
      var direction = $(ev.currentTarget).data('section-nav');
      this.getDelegate().activateSectionByDirection(direction);
    },
    handleSideBarKeydown: function handleSideBarKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleSideBarToggle(ev);
      }
    },
    handleSideBarToggle: function handleSideBarToggle() {
      this.$('.content-body').add('.content-toolbar').add('.empty-form').toggleClass('closed-sidebar');
      this.$('.diff-iframe-container').toggleClass('closed-sidebar');
      setTimeout(function () {
        this.refresh();
      }.proxy(this), 350);
    },
    handleDiffControlKeydown: function handleDiffControlKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleDiffControlClick(ev);
      }
    },
    handleDiffControlClick: function handleDiffControlClick(ev) {
      var action = $(ev.currentTarget).data('action'),
        activeIndex = this._activeDiff;
      switch (action) {
        case 'previous':
          this.setActiveHighlight(--activeIndex);
          break;
        case 'next':
          this.setActiveHighlight(++activeIndex);
          break;
      }
    },
    showForms: function showForms() {
      this.$('.form-diff-container').addClass('show-forms');
    },
    hideForms: function hideForms() {
      this.$('.form-diff-container').removeClass('show-forms');
    },
    render: function render() {
      this.$el.html(this.renderInitFragment());
    },
    resetScroll: function resetScroll() {
      this.$(".form-diff-container").scrollTop(0);
    },
    renderSections: function renderSections() {
      var sections = this.getDelegate().getSections(),
        sidebarContainer = this.getSideBarContainer(),
        section = null,
        sidebarFragment = null,
        el = null;
      this.getSideBarContainer().children().remove('.form-sidebar-section');
      for (var i = 0, len = sections.length; i < len; i++) {
        section = sections[i];
        sidebarFragment = this.renderSectionRowFragment(_.extend({
          count: this.getDelegate().getDiffDataCount(section)
        }, section));
        el = sidebarFragment.children();
        helper.datum(el, section);
        sections[i].sidebarEl = el;
        sidebarContainer.append(sidebarFragment);
      }
    },
    refreshSectionNavigation: function refreshSectionNavigation() {
      var previous = $('[data-section-nav="previous"]'),
        next = $('[data-section-nav="next"]'),
        delegate = this.getDelegate(),
        sections = delegate.getSections(),
        index = sections.indexOf(delegate.getActiveSection());
      this.toggleClass(previous, 'disabled', index == 0);
      this.toggleClass(next, 'disabled', index == sections.length - 1);
    },
    toggleClass: function toggleClass(el, classes, condition) {
      if (condition) {
        el.addClass(classes);
      } else {
        el.removeClass(classes);
      }
    },
    refreshHeightDifferences: function refreshHeightDifferences() {
      var differentFo = this.getDelegate().getFormObjectsWithDifferingHeight(),
        right = differentFo.right,
        left = differentFo.left,
        rightEl = null,
        leftEl = null,
        newHeight = 0;
      for (var i = 0, len = right.length; i < len; i++) {
        rightEl = right[i].getView().getContentElement();
        leftEl = left[i].getView().getContentElement();
        if (leftEl.height() != rightEl.height()) {
          newHeight = Math.max(leftEl.height(), rightEl.height());
          leftEl.height(newHeight);
          rightEl.height(newHeight);
        }
      }
    },
    refresh: function refresh() {
      var vline = $(".form-diff-spacer-wrapper");
      this.refreshSectionNavigation();
      vline.height(10);
      this.visualizeTextDiffAll();
      this.refreshHeightDifferences();
      this.refreshHighlights();
      this.refreshSideBar();
      vline.height(vline.parent().get(0).scrollHeight);
    },
    enableDocumentSelector: function enableDocumentSelector() {
      this.$('.document-selector').show();
    },
    setTitle: function setTitle(title) {
      this.$('.form-diff-document-title').text(title);
    },
    refreshSideBar: function refreshSideBar() {
      var previousActive = this.getSideBarContainer().find('.active'),
        active = this.getDelegate().getActiveSection();
      previousActive.removeClass('active');
      active ? active.sidebarEl.addClass('active') : null;
    },
    removeAllHightlights: function removeAllHightlights() {
      this.getHighlightContainer().empty();
    },
    visualizeTextDiffAll: function visualizeTextDiffAll() {
      var delegate = this.getDelegate(),
        activeSection = delegate.getActiveSection();
      if (activeSection) {
        var changed = delegate.getChangedFormObjects(activeSection.right),
          leftChanged = delegate.getChangedFormObjects(activeSection.left);
        for (var i = 0, len = changed.length; i < len; i++) {
          if (changed[i].type === "textbox" || changed[i].type === "textarea") {
            var leftEl = leftChanged[i],
              rightEl = changed[i];
            this.visualizeTextDiff(leftEl, rightEl);
          }
        }
      }
    },
    refreshHighlights: function refreshHighlights() {
      var delegate = this.getDelegate(),
        activeSection = delegate.getActiveSection(),
        hlContainer = this.getHighlightContainer();
      if (activeSection) {
        var changed = delegate.getChangedFormObjects(activeSection.right),
          leftChanged = delegate.getChangedFormObjects(activeSection.left),
          hiddenRight = delegate.getHiddenFormObjects(activeSection.right),
          hiddenLeft = delegate.getHiddenFormObjects(activeSection.left);
        hlContainer.empty();
        for (var i = 0, len = changed.length; i < len; i++) {
          var changeEl = changed[i].getView().$el,
            leftChangeEl = leftChanged[i].getView().$el,
            classes = 'full',
            twinFormObjectId,
            $twinFormObject;
          if (changed[i].type === "radio" || changed[i].type === "checkbox") {
            if (!changed[i].getValue()) {
              classes = "left";
            } else {
              classes = "right";
            }
          }
          this.addHighlight(changeEl, classes);
        }
        for (var i = 0, len = hiddenRight.length; i < len; i++) {
          this.addHighlight(hiddenRight[i].getView().$el, "red left");
          twinFormObjectId = 'prev-' + hiddenRight[i].getView().$el.attr('id');
          $twinFormObject = $('#' + twinFormObjectId);
          if ($twinFormObject.find('.accessibility-text').length === 0) {
            $twinFormObject.prepend('<div class="accessibility-text"> begin removed content </div>').append('<div class="accessibility-text"> end removed content </div>');
          }
        }
        for (var i = 0, len = hiddenLeft.length; i < len; i++) {
          this.addHighlight(hiddenLeft[i].getView().$el, "green right");
          twinFormObjectId = hiddenLeft[i].getView().$el.attr('id').substr(5);
          $twinFormObject = $('#' + twinFormObjectId);
          if ($twinFormObject.find('.accessibility-text').length === 0) {
            $twinFormObject.prepend('<div class="accessibility-text"> begin added content </div>').append('<div class="accessibility-text"> end added content </div>');
          }
        }
        if (this._activeDiff) {
          this.setActiveHighlight(this._activeDiff);
        } else {
          this.setActiveHighlight(0);
        }
      }
      this.refreshDiffCount();
    },
    visualizeTextDiff: function visualizeTextDiff(leftEl, rightEl) {
      if (leftEl.id !== rightEl.id) {
        throw new Error("Internal UI error: left and right IDs are different in prep for diff visualization");
      }
      var diffs = rightEl.diffs;
      if (!diffs) {
        diffs = leftEl.diffs;
      }
      if (diffs) {
        this.rerenderWithDiffVisualization('left', leftEl, diffs);
        this.rerenderWithDiffVisualization('right', rightEl, diffs);
      }
    },
    rerenderWithDiffVisualization: function rerenderWithDiffVisualization(leftOrRight, docEl, diffs) {
      var contentElement = docEl.view.$el.find('.visual-diff-support,.redactor_visual-diff-support');
      contentElement.css('display', 'none');
      var parentElement = docEl.view.$el.find('.form-object-content-controls');
      var divElt = parentElement.children(".visual-diff-text");
      if (parentElement.length === 1) {
        if (divElt.length === 0) {
          divElt = $("<div class=\"visual-diff-text\"></div>");
          parentElement.append(divElt);
        } else {
          divElt.children().remove();
        }
      } else if (parentElement.length > 0) {
        Object.entries(parentElement).map(function (item) {
          var _item = _slicedToArray(item, 2),
            key = _item[0],
            value = _item[1];
          if (_typeof(value) === 'object') {
            var _$childElement$;
            var $childElement = $(value);
            if (divElt.length === 0 && (_$childElement$ = $childElement[0]) !== null && _$childElement$ !== void 0 && (_$childElement$ = _$childElement$.innerHTML) !== null && _$childElement$ !== void 0 && _$childElement$.includes('visual-diff-support')) {
              divElt = $("<div class=\"visual-diff-text\"></div>");
              $childElement.append(divElt);
            } else {
              divElt.children().remove();
            }
          }
        });
      }
      diffs.forEach(function (part) {
        if (leftOrRight === "left" && part.added) return;
        if (leftOrRight === "right" && part.removed) return;
        var diffClass = part.added ? "diff-added" : part.removed ? "diff-removed" : "diff-unchanged";
        var modificationTypeString = part.added ? "added" : part.removed ? "removed" : "unchanged";
        var span = '<span class="' + diffClass + '"><span class="accessibility-text"> begin ' + modificationTypeString + ' content </span>' + part.value + '<span class="accessibility-text"> end ' + modificationTypeString + ' content </span>' + '</span>';
        divElt.append(span);
      });
      if (divElt.children().length == 0) {
        divElt.append("<span class=\"diff-unchanged\">&nbsp;</span>");
      }
      return divElt;
    },
    refreshDiffCount: function refreshDiffCount() {
      var count = this.getHighlightContainer().find('.diff-highlight-row').length;
      var comparisonString = count === 1 ? ' comparison' : ' comparisons';
      this.$('.form-diffs-count').html(count).attr({
        'aria-label': count + comparisonString + ' in this section'
      });
    },
    getFormDiffContainer: function getFormDiffContainer() {
      return this.$('.form-diff-container');
    },
    getFormDiffControls: function getFormDiffControls() {
      return this.$('.form-diff-controls');
    },
    getFormContainer: function getFormContainer() {
      return this.$('.form-container');
    },
    getDiffPanelHeader: function getDiffPanelHeader() {
      return this.$('.diff-panel-header');
    },
    getAttachmentDiffViewerClose: function getAttachmentDiffViewerClose() {
      return this.$('.attachment-diff-viewer-close');
    },
    getHighlightContainer: function getHighlightContainer() {
      return this._hlContainer || (this._hlContainer = this.$('.diff-highlight-container'));
    },
    getDiffIframeContainer: function getDiffIframeContainer() {
      return this.$('.diff-iframe-container');
    },
    findSelectedAttachmentControl: function findSelectedAttachmentControl(formObjectId, leftOrRight, checked) {
      var selector = 'input[name=' + formObjectId + '-' + leftOrRight + ']';
      if (checked) {
        selector = selector + ':checked';
      }
      return $(selector);
    },
    isDiffViewer: function isDiffViewer() {
      return true;
    },
    addHighlight: function addHighlight($element, classes) {
      var highlightEl = $(document.createElement('div')).addClass('diff-highlight-row').addClass(classes),
        hlContainer = this.getHighlightContainer(),
        self = this,
        compareButton = $element.find('.compare-button'),
        formObjectId = $element.attr('id');
      if (formObjectId && formObjectId.indexOf('prev-') !== -1) {
        formObjectId = formObjectId.split('prev-').join('');
      }
      var enableCompareButton = function enableCompareButton() {
        if (this.findSelectedAttachmentControl(formObjectId, 'left', 'checked').length > 0 && this.findSelectedAttachmentControl(formObjectId, 'right', 'checked').length > 0) {
          compareButton.addClass('active');
          compareButton.attr('aria-disabled', 'false');
        }
      };
      var prepareForAttachmentComparison = function prepareForAttachmentComparison(leftOrRight) {
        var PREFIX = leftOrRight === 'left' ? 'prev-' : '';
        var formObject = $('div.form-container-' + leftOrRight).find('#' + PREFIX + formObjectId);
        var attachmentObjects = formObject.find('.attachment-object a');
        var attachmentSelectors = formObject.find('input.attachment-compare-selector');
        attachmentSelectors.css('display', 'inline-block');
        attachmentSelectors.prop('name', formObjectId + '-' + leftOrRight);
        if (attachmentObjects.filter('.file-attachment').length === 1) {
          attachmentSelectors.first().prop("checked", true);
          enableCompareButton.bind(self)();
        }
        return attachmentObjects;
      };
      var hideAttachmentsSelectorsIfNotNeeded = function hideAttachmentsSelectorsIfNotNeeded(attachmentObjectsLeft, attachmentObjectsRight) {
        if (attachmentObjectsLeft.length === 1 && attachmentObjectsRight.length === 1) {
          var bothFormObjects = $('*[id*="' + formObjectId + '"], *[id*="prev-' + formObjectId + '"]');
          var attachmentSelectors = bothFormObjects.find('input.attachment-compare-selector');
          attachmentSelectors.css('display', 'none');
          if (attachmentObjectsLeft.filter('.file-attachment').length > 0 && attachmentObjectsRight.filter('.file-attachment').length > 0) {
            compareButton.addClass('active');
            compareButton.attr('aria-disabled', 'false');
          }
        }
      };
      var setCompareButtonToActivateWhenReadyToCompare = function setCompareButtonToActivateWhenReadyToCompare(compareButton, formObjectId) {
        var self = this;
        this.findSelectedAttachmentControl(formObjectId, 'left').each(function () {
          this.onclick = enableCompareButton.bind(self);
        });
        this.findSelectedAttachmentControl(formObjectId, 'right').each(function () {
          this.onclick = enableCompareButton.bind(self);
        });
      };
      highlightEl.css('top', $element.offset().top - hlContainer.offset().top - 3);
      highlightEl.height($element.outerHeight());
      hlContainer.append(highlightEl);
      if (compareButton) {
        var attachmentObjectsLeft = prepareForAttachmentComparison('left'),
          attachmentObjectsRight = prepareForAttachmentComparison('right');
        compareButton.attr('data-formObjectId', formObjectId);
        setCompareButtonToActivateWhenReadyToCompare.bind(this)(compareButton, formObjectId);
        hideAttachmentsSelectorsIfNotNeeded.bind(this)(attachmentObjectsLeft, attachmentObjectsRight);
        if (attachmentObjectsLeft && attachmentObjectsRight) {
          compareButton.attr('id', 'compareBtn-' + _.uniqueId());
        }
      }
      return highlightEl;
    },
    setNavigationPreviousText: function setNavigationPreviousText(text) {
      $('.rs-navigation-previous').contents().filter(function () {
        return this.nodeType == 3 && this.textContent.trim().length > 0;
      }).each(function () {
        this.textContent = text;
      });
    },
    compareAttachments: function compareAttachments(formObjectId) {
      if (!Array.prototype.last) {
        Array.prototype.last = function () {
          return this[this.length - 1];
        };
      }
      ;
      var leftSelectedAttachment = JSON.parse(this.findSelectedAttachmentControl(formObjectId, 'left', 'checked').val());
      var filenameLeft = leftSelectedAttachment.fileName.trim();
      var docStoreIdLeft = leftSelectedAttachment.docStoreId.split('/').last();
      var rightSelectedAttachment = JSON.parse(this.findSelectedAttachmentControl(formObjectId, 'right', 'checked').val());
      var filenameRight = rightSelectedAttachment.fileName.trim();
      var docStoreIdRight = rightSelectedAttachment.docStoreId.split('/').last();
      this.renameDiffPanelHeader(filenameLeft, filenameRight);
      this.getAttachmentDiffViewerClose().css('display', 'block');
      this.getDelegate().compareAttachments(docStoreIdLeft, docStoreIdRight);
    },
    renameDiffPanelHeader: function renameDiffPanelHeader(filenameLeft, filenameRight) {
      var diffPanelHeader = this.getDiffPanelHeader();
      diffPanelHeader.find('.previous-submission')[0].textContent = filenameLeft;
      diffPanelHeader.find('.current-submission')[0].textContent = filenameRight;
    },
    showDocumentDiffViewer: function showDocumentDiffViewer(diffViewerUrl) {
      this.$('.attachment-diff-iframe').attr('src', diffViewerUrl);
    },
    hideDocumentDiffViewer: function hideDocumentDiffViewer() {
      this.getAttachmentDiffViewerClose().css('display', 'none');
      this.renameDiffPanelHeader('PREVIOUS SUBMISSION', 'CURRENT SUBMISSION');
      this.$('.diff-iframe-container').css('display', 'none');
      this.setNavigationPreviousText('VIEW SUBMISSION');
      $('div.form-section-navigation').removeClass('disabled');
    },
    setActiveHighlight: function setActiveHighlight(index) {
      var diffs = this.getHighlightContainer().find('.diff-highlight-row'),
        activeDiff = null;
      if (index > diffs.length - 1 || index == null) {
        index = 0;
      } else if (index < 0) {
        index = diffs.length - 1;
      }
      activeDiff = diffs.get(index);
      this._activeDiff = index;
      if (!activeDiff) {
        return;
      }
      diffs.removeClass('active');
      activeDiff = $(activeDiff);
      activeDiff.addClass('active');
      this.getFormDiffContainer().animate({
        scrollTop: activeDiff.position().top
      });
    },
    resize: function resize() {
      this._super();
      this.refreshHighlights();
    },
    handleDocumentSelectorChange: function handleDocumentSelectorChange(ev) {
      var option = $(ev.currentTarget).val();
      this.getDelegate().requestChangePreviousAnswers(option);
    },
    setDocumentSelector: function setDocumentSelector(value) {
      this.$('.document-selector').val(value);
    },
    getFormRightContainerElement: function getFormRightContainerElement() {
      return this.$('.form-container-right');
    },
    getFormLeftContainerElement: function getFormLeftContainerElement() {
      return this.$('.form-container-left');
    },
    getSideBarContainer: function getSideBarContainer() {
      return this.$('.form-diff-sidebar-scroller');
    },
    showEmptyPreviousFormMessage: function showEmptyPreviousFormMessage() {
      this.$('.form-container-left').hide();
      this.$('.empty-form').show();
    },
    hideEmptyPreviousFormMessage: function hideEmptyPreviousFormMessage() {
      this.$('.empty-form').hide();
      this.$('.form-container-left').show();
    }
  });
  module.exports = DocumentDiffView;
});

